<script>
    import { t, relativeTime } from "../../i18n";
    import {push} from 'svelte-spa-router'
    import API from "../../class/API";
    import {onMount} from "svelte";


    $: error = null;
    $: content = null;
    $: loading = true;

    $: notifications = content || [];
    $: unreadNotifications = notifications.length;
    $: hasNotifications = unreadNotifications>0;

    onMount(() => setTimeout(()=>update(), 10));


    setInterval(()=>update(), 60*1000);


    let pathToQid = function(path){
        let isQuotation = path.match(/^agents\/\d+\/Q\d+$/i); if(!isQuotation)return null;
        let qid = path.replace(/.*?\/Q(\d+)$/i, '$1'); if(!(qid+'').match(/^\d+$/)) return null;
        return qid;
    }
    let pathToUrl = function(path){
        if(!path)return null;
        let isGeneral = path.match(/^agents\/\d+$/); if(isGeneral)return '#/chat';
        let isQuotation = path.match(/^agents\/\d+\/Q\d+$/i);
        if(isQuotation){
            let q = pathToQid(path);
            return q ? '#/quotation/' + q : null;
        }
        return null;
    };

    export function update()
    {
        console.log("Notification update....");
        API('notes.get.notifs')
            .then(data => { if(error)error=null; content = data; })
            .catch(err => error = err)
            .finally(() => loading = false);
    }

    let sendToPage = function(notifPath){
        let url = pathToUrl(notifPath); if(!url)return;
        setTimeout(() => update(), 4000);
        push(url);
    }


</script>



<li class="dropdown dropdown-notification nav-item">
    <a class="nav-link nav-link-label" href="#" data-toggle="dropdown">
        <i class="ficon bx bx-bell bx-flip-horizontal" class:bx-tada={hasNotifications}></i>
        <span class="badge badge-pill badge-up" class:badge-danger={hasNotifications}>{unreadNotifications}</span>
    </a>
    <ul class="dropdown-menu dropdown-men/u-media dropdown-menu-right">
        <li class="dropdown-menu-header">
            <div class="dropdown-header px-1 py-75 d-flex justify-content-between"><span class="notification-title">{$t('notif.count', {n: unreadNotifications})}</span><span class="text-bold-400 cursor-pointer"></span></div>
        </li>
        <li class="scrollable-container media-list">

            {#each notifications as notif}

                <a class="d-flex justify-content-between cursor-pointer" href={pathToUrl(notif.path)} style="min-width: 300px;" on:click|preventDefault={() => sendToPage(notif.path)}>
                    <div class="media d-flex align-items-center">
                        <div class="media-left pr-0">
                            <div class="avatar bg-primary bg-lighten-5 mr-1 m-0 p-25"><span class="avatar-content text-primary font-medium-2">{pathToQid(notif.path) || '-'}</span></div>
                        </div>
                        <div class="media-body">
                            <h6 class="media-heading">{notif.content}</h6>
                            <small class="notification-text">{$relativeTime(notif.time)}</small>
                        </div>
                    </div>
                </a>



            {:else}
                <div class="media d-flex align-items-center">
                    <div class="media-body">
                        {$t('notif.empty')}
                    </div>
                </div>
            {/each}


        </li>

        <!--
        <li class="dropdown-menu-footer"><a class="dropdown-item p-50 text-primary justify-content-center" href="javascript:void(0)">Mark all as read</a></li>
        -->
    </ul>
</li>